import React, { useState } from 'react'
import MailCheck from 'react-mailcheck'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'
import { TextInput, Link } from '@olxbr/ds-web'
import PropTypes from 'prop-types'

const domains = [
  'gmail.com',
  'hotmail.com',
  'outlook.com',
  'yahoo.com',
  'yahoo.com.br',
  'icloud.com',
  'bol.com.br',
  'live.com',
  'outlook.com.br',
  'uol.com.br',
  'terra.com.br',
  'ig.com.br',
]

const secondLevelDomains = ['yahoo', 'hotmail', 'live', 'outlook']

const topLevelDomains = ['com', 'com.br']

const Wrapper = styled(View)`
  display: flex;
  flex-direction: row;
  margin-top: var(--spacing-1);
  margin-bottom: var(--spacing-1);
`

const EmailWrapper = styled(View)`
  display: flex;
  flex-direction: row;
  margin-left: var(--spacing-0-5);
`

const DidYouMean = ({ address, domain, onClick }) => (
  <Wrapper>
    <span className="typo-body-small">Deseja usar</span>
    <Link size="small" onMouseDown={() => onClick && onClick(`${address}@${domain}`)}>
      <EmailWrapper>
        {`${address}@`}
        <b>{domain}</b>
      </EmailWrapper>
    </Link>
    <span className="typo-body-small">?</span>
  </Wrapper>
)

const handleError = error => {
  return typeof error == 'function' ? error() : error
}

const MailCheckInput = ({
  value,
  error,
  hasError,
  inputRef,
  disabled,
  onBlur,
  onChange,
  onSuggestionClick,
  caption,
  label,
  placeholder,
  onFocus,
}) => {
  const [showSuggestion, setShowSuggestion] = useState(true)

  const handleAction = (handler, showSuggestion) => event => {
    if (handler) {
      handler(event)
    }

    setShowSuggestion(showSuggestion)
  }

  return (
    <MailCheck
      email={value}
      domains={domains}
      domainThreshold={4}
      secondLevelDomains={secondLevelDomains}
      secondLevelThreshold={3}
      topLevelDomains={topLevelDomains}
      topLevelThreshold={1}
    >
      {suggestion => (
        <React.Fragment>
          <TextInput
            label={label}
            aria-label="email"
            caption={caption}
            placeholder={placeholder}
            ref={inputRef}
            disabled={disabled}
            id="input-1"
            type="email"
            value={value}
            onChange={handleAction(onChange, true)}
            onBlur={handleAction(onBlur, false)}
            stateMessage={handleError(error) || 'Campo obrigatório. Informe um e-mail válido.'}
            state={hasError ? 'error' : undefined}
            onFocus={onFocus}
          />

          {suggestion && showSuggestion && !disabled && (
            <DidYouMean
              address={suggestion.address}
              domain={suggestion.domain}
              onClick={onSuggestionClick}
            />
          )}
        </React.Fragment>
      )}
    </MailCheck>
  )
}

MailCheckInput.propTypes = {
  value: PropTypes.string,
  hasError: PropTypes.bool,
  inputRef: PropTypes.func,
  disabled: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  caption: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  onFocus: PropTypes.func,
}

export default MailCheckInput
